import { useEffect } from "react";

export type ToastKind = "info" | "error" | "success";

interface Props {
  message: string;
  kind?: ToastKind;
  onDismiss: () => void;
}

export function Toast({ message, kind = "info", onDismiss }: Props) {
  useEffect(() => {
    const t = setTimeout(onDismiss, 4000);
    return () => clearTimeout(t);
  }, [message, onDismiss]);

  const colors =
    kind === "error"
      ? "bg-rose-50 border-rose-200 text-rose-800"
      : kind === "success"
      ? "bg-emerald-50 border-emerald-200 text-emerald-800"
      : "bg-stone-50 border-stone-200 text-stone-800";

  return (
    <div className={`fixed bottom-3 left-3 right-3 border rounded-md px-3 py-2 text-sm shadow-sm ${colors}`}>
      {message}
    </div>
  );
}
